const o = (r) => Array.isArray(r) ? r : r !== void 0 ? [r] : [];
export {
  o as toArray
};
